import { CheckUtils, ConversationVoData, JabberJidVoData, JabberSendMessageData, MessageSourceVoData, MessageVoData } from "../..";
var ChatConverter = /** @class */ (function () {
    function ChatConverter() {
    }
    ChatConverter.convertToJidVoData = function (jid) {
        if (CheckUtils.isEmpty(jid))
            return null;
        var result = new JabberJidVoData(jid.bare, jid._isJID);
        result.full = jid.full;
        result.prepped = jid.prepped;
        result.resource = jid.resource;
        result.unescapedBare = jid.unescapedBare;
        result.unescapedFull = jid.unescapedFull;
        result.unescapedLocal = jid.unescapedLocal;
        return result;
    };
    ChatConverter.convertToJabberJidResultData = function (jid) {
        if (CheckUtils.isEmpty(jid))
            return null;
        var result;
        if (typeof jid === "string") {
            result = jid;
        }
        else {
            result = jid.bare;
        }
        return result;
    };
    ChatConverter.convertToConversationVoData = function (conversation) {
        if (CheckUtils.isEmpty(conversation))
            return null;
        var result = new ConversationVoData(conversation.jabberId);
        result.id = conversation.id;
        result.authorId = conversation.authorId;
        result.createdDate = conversation.created;
        result.visibility = conversation.visibility;
        result.lastPosted = conversation.lastPosted;
        result.itemId = conversation.itemId;
        result.projectId = conversation.projectId;
        result.status = conversation.state;
        result.locked = conversation.locked;
        return result;
    };
    ChatConverter.convertJabberToMessageVoData = function (message) {
        if (CheckUtils.isEmpty(message))
            return null;
        var result = new MessageVoData();
        result.uid = message.id;
        result.authorJabberId = message.from.resource;
        result.createdDate = (CheckUtils.isEmpty(message.delay) || CheckUtils.isEmpty(message.delay.stamp)) ?
            Date.now() : message.delay.stamp.getTime();
        result.data = message.body;
        result.source = MessageSourceVoData.JABBER;
        result.type = message.type;
        return result;
    };
    ChatConverter.convertToJabberMessageData = function (message) {
        if (CheckUtils.isEmpty(message))
            return null;
        var result = new JabberSendMessageData();
        result.id = message.uid;
        result.to = this.convertToJabberJidResultData(message.to);
        result.from = this.convertToJabberJidResultData(message.authorJabberId);
        result.body = message.data;
        result.type = message.type;
        return result;
    };
    ChatConverter.convertToMessageVoData = function (message) {
        if (CheckUtils.isEmpty(message))
            return null;
        var result = new MessageVoData();
        result.id = message.id;
        result.uid = message.jabberId;
        result.authorId = message.authorId;
        result.authorJabberId = message.authorJabberId;
        result.data = message.content;
        result.source = message.source;
        result.createdDate = message.created;
        result.isDeleted = message.deleted;
        result.isEdited = message.edited;
        result.files = [];
        return result;
    };
    return ChatConverter;
}());
export { ChatConverter };
//# sourceMappingURL=chat-converter.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/utils/converter/chat-converter.js
// module id = 961
// module chunks = 14